import { epicRequest } from 'app'

export const NOTIFICATIONS_DELETE = 'NOTIFICATIONS_DELETE'
export const NOTIFICATIONS_DELETE_ERROR = 'NOTIFICATIONS_DELETE_ERROR'
export const NOTIFICATIONS_DELETE_FULFILLED = 'NOTIFICATIONS_DELETE_FULFILLED'
export const NOTIFICATIONS_DELETE_CANCELED = 'NOTIFICATIONS_DELETE_CANCELED'

export const NOTIFICATIONS_FETCH = 'NOTIFICATIONS_FETCH'
export const NOTIFICATIONS_FETCH_ERROR = 'NOTIFICATIONS_FETCH_ERROR'
export const NOTIFICATIONS_FETCH_FULFILLED = 'NOTIFICATIONS_FETCH_FULFILLED'
export const NOTIFICATIONS_FETCH_CANCELED = 'NOTIFICATIONS_FETCH_CANCELED'

export const NOTIFICATIONS_READ = 'NOTIFICATIONS_READ'
export const NOTIFICATIONS_READ_ERROR = 'NOTIFICATIONS_READ_ERROR'
export const NOTIFICATIONS_READ_FULFILLED = 'NOTIFICATIONS_READ_FULFILLED'
export const NOTIFICATIONS_READ_CANCELED = 'NOTIFICATIONS_READ_CANCELED'

export const NOTIFICATIONS_VIEW = 'NOTIFICATIONS_VIEW'
export const NOTIFICATIONS_VIEW_ERROR = 'NOTIFICATIONS_VIEW_ERROR'
export const NOTIFICATIONS_VIEW_FULFILLED = 'NOTIFICATIONS_VIEW_FULFILLED'
export const NOTIFICATIONS_VIEW_CANCELED = 'NOTIFICATIONS_VIEW_CANCELED'

export const NOTIFICATIONS_INITIAL_STATE = {
  all: {
    data: [
      {
        digest_email_time: '',
        notifications: [],
      },
    ],
    error: null,
    loaded: false,
    loading: false,
    page: null,
    pagination: null,
  },
  loaded: false,
  read: {
    data: [],
    error: null,
    loaded: false,
    page: null,
    pagination: null,
  },
  unread: {
    data: [],
    error: null,
    loaded: false,
    page: null,
    pagination: null,
  },
  unseen: {
    data: [],
    error: null,
    loaded: false,
    page: null,
    pagination: null,
  },
}

export const notificationsFetch = ({ page = 1, perPage = 5, type = 'all' } = {}) => ({
  payload: { page, perPage, type },
  type: NOTIFICATIONS_FETCH,
})

export const notificationsFetchFulfilled = (payload) => ({
  payload,
  type: NOTIFICATIONS_FETCH_FULFILLED,
})

export const notificationsFetchCanceled = () => ({
  payload: null,
  type: NOTIFICATIONS_FETCH_CANCELED,
})

export const notificationsFetchError = (payload) => ({
  payload,
  type: NOTIFICATIONS_FETCH_ERROR,
})

export const notificationsFetchEpic = epicRequest({
  actionType: NOTIFICATIONS_FETCH,
  errorAction: notificationsFetchError,
  fulfilledAction: (response, action) => {
    response.type = action.payload.type
    return notificationsFetchFulfilled(response)
  },
  request: ({ payload }) => {
    const page = payload.page > 1 ? `?page=${payload.page}&` : '?'
    let { type } = payload
    if (payload.type === 'all' || !payload.type) {
      type = ''
    }
    return `user/notifications/${type}${page}per_page=${payload.perPage}`
  },
  untilTypes: NOTIFICATIONS_FETCH_CANCELED,
})

export const notificationsRead = (id) => ({
  payload: { id },
  type: NOTIFICATIONS_READ,
})

export const notificationsReadFulfilled = (payload) => ({
  payload,
  type: NOTIFICATIONS_READ_FULFILLED,
})

export const notificationsReadCanceled = () => ({
  payload: null,
  type: NOTIFICATIONS_READ_CANCELED,
})

export const notificationsReadError = (payload) => ({
  payload,
  type: NOTIFICATIONS_READ_ERROR,
})

export const notificationsReadEpic = epicRequest({
  actionType: NOTIFICATIONS_READ,
  errorAction: notificationsReadError,
  fulfilledAction: (response, action) => {
    response.id = action.payload.id
    return notificationsReadFulfilled(response)
  },
  request: ({ payload }) => ({
    body: {},
    method: 'put',
    url: `user/notifications/${payload.id}/read`,
  }),
  untilTypes: NOTIFICATIONS_READ_CANCELED,
})

export const notificationsDelete = (id) => ({
  payload: { id },
  type: NOTIFICATIONS_DELETE,
})

export const notificationsDeleteFulfilled = (payload) => ({
  payload,
  type: NOTIFICATIONS_DELETE_FULFILLED,
})

export const notificationsDeleteCanceled = () => ({
  payload: null,
  type: NOTIFICATIONS_DELETE_CANCELED,
})

export const notificationsDeleteError = (payload) => ({
  payload,
  type: NOTIFICATIONS_DELETE_ERROR,
})

export const notificationsDeleteEpic = epicRequest({
  actionType: NOTIFICATIONS_DELETE,
  errorAction: notificationsDeleteError,
  fulfilledAction: (response, action) => {
    response.id = action.payload.id
    return notificationsDeleteFulfilled(response)
  },
  request: ({ payload }) => ({
    method: 'delete',
    url: `user/notifications/${payload.id}`,
  }),
  untilTypes: NOTIFICATIONS_DELETE_CANCELED,
})

export const notificationsView = () => ({
  payload: {},
  type: NOTIFICATIONS_VIEW,
})

export const notificationsViewFulfilled = (payload) => ({
  payload,
  type: NOTIFICATIONS_VIEW_FULFILLED,
})

export const notificationsViewCanceled = () => ({
  payload: null,
  type: NOTIFICATIONS_VIEW_CANCELED,
})

export const notificationsViewError = (payload) => ({
  payload,
  type: NOTIFICATIONS_VIEW_ERROR,
})

export const notificationsViewEpic = epicRequest({
  actionType: NOTIFICATIONS_VIEW,
  errorAction: notificationsViewError,
  fulfilledAction: notificationsViewFulfilled,
  request: () => ({
    method: 'put',
    url: 'user/notifications/view',
  }),
  untilTypes: NOTIFICATIONS_VIEW_CANCELED,
})
